import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Tippy from '@tippyjs/react'
import classNames from 'classnames/bind'
import { useReactAlert } from 'src/hooks/useReactAlert'
import { StudentReportGetDto } from '../../../../../model/student-model'
import EditButtonsPopup from './edit-button-popup'
import ReportModal from '../report-modal'
import UserProfileService from '../../../../../services/common-services/user-profile-service'

import styles from './report-card.module.scss'
import StudentReportService from '../../../../../services/student-services/student-report-service'
import { convertResponseImageUrl } from '../../../../../utils/convertResponseImageUrl'

const cx = classNames.bind(styles)

type ReportCardProps = {
  report: StudentReportGetDto
  currentStudentId?: number
  getStudentReports: () => void
}
const ReportCard: FC<ReportCardProps> = ({ report, currentStudentId, getStudentReports }) => {
  const { catchErrorAlert } = useReactAlert()
  const { text, countHours, firstName, lastName, reportDate, id, studentId } = report
  const { t } = useTranslation()
  const userProfileService = new UserProfileService()

  const [isShortText, setIsShortText] = useState(true)
  const [visible, setVisible] = useState(false)
  const [showReportModal, setShowReportModal] = useState(false)
  const [uploadedImageURL, setUploadedImageURL] = useState<string | null>()

  useEffect(() => {
    userProfileService
      .getUserProfileById(studentId)
      .then(user => {
        if (user.avatarUrl) {
          setUploadedImageURL(convertResponseImageUrl(user.avatarUrl))
        }
      })
      .catch(err => catchErrorAlert(err))
  }, [])

  const show = () => {
    setVisible(true)
  }
  const hide = () => {
    setVisible(false)
  }
  const deleteReport = () => {
    const reportService = new StudentReportService()
    reportService
      .deleteStudentReport(id)
      .then(() => getStudentReports())
      .catch(err => catchErrorAlert(err))
  }
  return (
    <div className={cx('report-card')}>
      <ReportModal
        show={showReportModal}
        onClose={() => setShowReportModal(false)}
        text={text}
        countHours={countHours}
        reportDate={reportDate}
        reportId={id}
        getStudentReports={getStudentReports}
      />
      {currentStudentId === studentId && (
        <div>
          <Tippy
            content={
              <EditButtonsPopup
                setShowReportModal={() => {
                  hide()
                  setShowReportModal(true)
                }}
                deleteReport={() => {
                  hide()
                  deleteReport()
                }}
              />
            }
            visible={visible}
            onClickOutside={hide}
            interactive
            placement="left"
            interactiveBorder={30}
            offset={[0, 0]}
          >
            <button
              aria-expanded="false"
              type="button"
              className={cx('edit-menu-btn', 'btn')}
              onClick={visible ? hide : show}
            >
              <i className="mdi mdi-dots-vertical" />
            </button>
          </Tippy>
        </div>
      )}
      <div className={cx('card-avatar')}>
        <img className={cx('card-img')} src={uploadedImageURL ?? '/images/man.png'} id="user_pic" alt="avatar" />
      </div>
      <div className={cx('report-data')}>
        <div className={cx('student-name')}>{`${firstName} ${lastName}`}</div>
        <div className={cx('student-birthday')}>{reportDate}</div>
        <div className={cx('spend-time')}>
          <b>{t('TimeTaken')}:</b> {countHours}
          {t('HourShort')}
        </div>
        <p className={cx('task-progress-text', { 'task-progress-text--expand_true': !isShortText })}>
          <b>{t('WhatDone')}:</b> {text}
        </p>
        {text.length > 100 && (
          <button type="button" onClick={() => setIsShortText(!isShortText)} className={cx('toggle-expand-text')}>
            {isShortText ? t('Show') : t('Hide')}
          </button>
        )}
      </div>
    </div>
  )
}

export default ReportCard
